var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.3749V15.4999H3.625L12.8417 6.28322L9.71667 3.15822L0.5 12.3749ZM15.2583 3.86655C15.5833 3.54155 15.5833 3.01655 15.2583 2.69155L13.3083 0.741553C12.9833 0.416553 12.4583 0.416553 12.1333 0.741553L10.6083 2.26655L13.7333 5.39155L15.2583 3.86655Z",
    fill: "#0A77C7"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.43fe98ab4c959404f8037051115e5446.svg";
export { ForwardRef as ReactComponent };